module.exports = __webpack_public_path__ + "media/alert-new-order.a20b9492.mp3";